module.exports = __webpack_public_path__ + "assets/b97.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b97.png
// module id = 690
// module chunks = 0